import { FC, Fragment } from "react";
import { Stack, Typography } from "@mui/material";
import { useAppSelector } from "@/store/hooks";
import { ResourceType } from "@/services/cloudchipr.api";
import { selectedResourcesByMasterIdSelector } from "@/store/resources-grid/selectors/grid/selection/selectedResourcesByMasterIdSelector";
import { resourcesMasterGridIdByResourceTypeSelector } from "@/store/resources-grid/selectors/grid/resourcesMasterGridIdByResourceTypeSelector";
import { CreateIntegrationResourcesTable } from "@/components/common/integration-dialogs/components/common/CreateIntegrationResourcesTable";

export interface CreateSlackMessageDialogTableProps {
  resourceType: ResourceType;
  label: string;
}

export const CreateSlackMessageDialogTable: FC<
  CreateSlackMessageDialogTableProps
> = ({ resourceType, label }) => {
  const masterGridId = useAppSelector((state) =>
    resourcesMasterGridIdByResourceTypeSelector(state, resourceType),
  );

  const selectedResources = useAppSelector((state) =>
    selectedResourcesByMasterIdSelector(state, masterGridId ?? ""),
  );

  if (!selectedResources) {
    return null;
  }

  return (
    <Stack>
      <Typography variant="body1" fontWeight="bold" mb={1}>
        {label}
      </Typography>
      <Typography variant="caption" fontSize="x-small" color="text.secondary">
        {selectedResources?.length && selectedResources?.length > 24 ? (
          <Fragment>
            Showing{" "}
            <Typography fontWeight="bold" fontSize="inherit" component="span">
              {25}
            </Typography>{" "}
            of{" "}
            <Typography fontWeight="bold" component="span" fontSize="inherit">
              {selectedResources?.length}
            </Typography>{" "}
            resources
          </Fragment>
        ) : (
          <Fragment>
            Showing{" "}
            <Typography fontWeight="bold" component="span" fontSize="inherit">
              {selectedResources.length}
            </Typography>{" "}
            resource{selectedResources.length > 1 ? "s" : ""}
          </Fragment>
        )}
      </Typography>

      <CreateIntegrationResourcesTable resourceType={resourceType} />
    </Stack>
  );
};
